import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MatchBoosterIcon(props: IconProps) {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <Box as="path" d="M0 0h24v24H0z" />
      <Box as="path" stroke="currentColor" d="M12 19v5m-3-5v3.333m6 .001V19" />
      <Box
        as="path"
        stroke="currentColor"
        strokeMiterlimit="10"
        d="M17.5 12.601A7.206 7.206 0 0 1 22.899 18H17.5v-5.399Zm-11 0A7.206 7.206 0 0 0 1.101 18H6.5v-5.399Zm0 6.899V9.38c0-3.625 2.061-7.018 5.403-8.858a.222.222 0 0 1 .195 0c3.34 1.832 5.402 5.233 5.402 8.859V19.5h-11Z"
      />
      <Box as="circle" cx="12" cy="8.5" r="2" stroke="currentColor" />
    </Icon>
  );
}
